"use client";

import { useEffect } from "react";
import { initStorageForPlatform } from "@/lib/storage-init";
import { getStoredTheme, applyTheme } from "@/lib/theme";

export function ThemeInit() {
  useEffect(() => {
    initStorageForPlatform().catch(() => {});
    applyTheme(getStoredTheme());

    // Listen for system theme changes when mode is "system"
    const mql = window.matchMedia("(prefers-color-scheme: dark)");
    function handleChange() {
      const mode = getStoredTheme();
      if (mode === "system") {
        applyTheme("system");
      }
    }
    mql.addEventListener("change", handleChange);
    return () => mql.removeEventListener("change", handleChange);
  }, []);

  return null;
}
